import PropTypes from 'prop-types';

export default {
  onExpandClick: PropTypes.func,
  expanded: PropTypes.bool,
  icon: PropTypes.element,
  tooltipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  tooltipLabel: PropTypes.node,
  tooltipDelay: PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/Cards/contextTypes.js
// module id = 410
// module chunks = 0